import { AddHighlightTypes } from './utils.types';

const addHighlight = (string: AddHighlightTypes) => {
  return (
    string
      ?.replace(/\[(.*?)\]/g, '<span class="text-primary font-medium">$1</span>')
      .replace(/\{(.*?)\}/g, '<span class="font-medium text-[#494949]">$1</span>') ?? ''
  );
};

export default addHighlight;
